import React, { useState, useEffect } from 'react';
import AuthService from '../services/AuthService';
import {  useNavigate, NavLink} from 'react-router-dom';
import { toast } from 'react-toastify';
import ApiService from "../services/ApiService";
import AreaChart from "../components/AreaChart";
import PieChart from "../components/PieChart";
import ProgressBarStats from "../components/ProgressBarStats";
import {formatPrice} from "../utils/helper";
import moment from "moment";
import dayjs from 'dayjs';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

import { DatePicker } from 'antd';
import 'antd/dist/reset.css'; // or use 'antd/dist/antd.css' for older versions
const { RangePicker } = DatePicker;

const Dashboard = () => {
    const navigate = useNavigate();
    
    const [isLoader, setIsLoader] = useState(false);
    const [stats, setStats] = useState([]);
    const [charts, setCharts] = useState([]);
    const [current_month, setCurrentMonth] = useState("");
    const [pieData, setPieData]= useState({
    'In Kitchen': 0,
    'Prepared': 0,
    'Dispatched': 0,
    'Delivered': 0,
    'Cancelled': 0
  });
    const [admin] = useState(JSON.parse(localStorage.getItem('admin')));
    const [dateRange, setDateRange] = useState([]);

    const handleDateChange = (dates, dateStrings) => {
        setApiData({ ...apiData, daterange: dates })
        // setDateRange(dates);
    };
    const ranges = {
        'Today': [dayjs(), dayjs()],
        'Yesterday': [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')],
        'Last Week': [dayjs().subtract(1, 'week').startOf('week'), dayjs().subtract(1, 'week').endOf('week')],
        'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
    };

    const [apiData, setApiData] = useState({
        daterange: [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')],
    });

useEffect(() => {
    const isAuthenticated = AuthService.getCurrentUser(); // Check if the user is authenticated
    if (!isAuthenticated) {
        navigate('/login'); // Redirect to dashboard if authenticated
    }
    getDashboard();

    const now = new Date();
    const options = { month: "short", year: "numeric" }; // e.g., Dec, 2024
    const formattedDate = now.toLocaleDateString("en-US", options);
    setCurrentMonth(formattedDate);

}, [navigate]);

useEffect(() => {
    if (apiData.daterange) {
        const allValuesExist = apiData.daterange.every(element => element !== null);
        if (allValuesExist) {
            getDashboard();
        }
    }

    
}, [apiData.daterange]);

const getHumanReadableDateRange = (dateRange) => {
    // const dateRange= apiData.daterange;
    if (!dateRange || dateRange.length !== 2) return "Custom Range";

    const [startDate, endDate] = dateRange;
    // const startDate = moment(start).startOf('day'); 
    // const endDate = moment(end).startOf('day');  

    // Check for common date ranges
    if (startDate.isSame(endDate, 'day')) {
        console.log('Same');

        if (startDate.isSame(moment(), 'day')) {
        return "Today";
        } else if (startDate.isSame(moment().subtract(1, 'day'), 'day')) {
        return "Yesterday";
        } else if (startDate.isSame(moment().add(1, 'day'), 'day')) {
        return "Tomorrow";
        } else {
        return startDate.format("MMM D, YYYY"); // Single day (e.g., "Oct 5, 2023")
        }
    }

    // Check for "Last 7 Days", "This Month", etc.
    if (endDate.isSame(moment(), 'day')) {
        if (startDate.isSame(moment().subtract(6, 'days'), 'day')) {
        return "Last 7 Days";
        } else if (startDate.isSame(moment().startOf('week'), 'day')) {
        return "This Week";
        } else if (startDate.isSame(moment().startOf('month'), 'day')) {
        return "This Month";
        }
    }

    // Check for "Last Week", "Last Month"
    if (
        startDate.isSame(moment().subtract(1, 'week').startOf('week'), 'day') &&
        endDate.isSame(moment().subtract(1, 'week').endOf('week'), 'day')
    ) {
        return "Last Week";
    } else if (
        startDate.isSame(moment().subtract(1, 'month').startOf('month'), 'day') &&
        endDate.isSame(moment().subtract(1, 'month').endOf('month'), 'day')
    ) {
        return "Last Month";
    }

    // Fallback to formatted range (e.g., "Oct 1 - Oct 7, 2023")
    if (startDate.year() === endDate.year()) {
        return `${startDate.format("MMM D")} - ${endDate.format("MMM D, YYYY")}`;
    } else {
        return `${startDate.format("MMM D, YYYY")} - ${endDate.format("MMM D, YYYY")}`;
    }
};


const getDashboard = async () => {
    try {
        setIsLoader(true);

        // Create a copy of apiData to modify daterange for the request
        const requestData = { ...apiData };
        if (requestData.daterange && Array.isArray(requestData.daterange)) {
            requestData.daterange = requestData.daterange.map(date => 
                date && dayjs.isDayjs(date) ? date.format('YYYY-MM-DD') : date
            );
        }

        const response = await ApiService.request({
            method: "GET",
            url: "getDashboard", // Replace with your API endpoint
            data: requestData
        });
        const data = response.data;
        if (data.status) {
            const stats = data.data.stats;
            setStats(data.data.stats);
            setCharts(data.data.charts);
            localStorage.setItem('map_key', data.data.map_key);
            setPieData({
                'In Kitchen': stats.preparing_orders,
                'Prepared': stats.prepared_orders,
                'Dispatched': stats.picked_up_orders,
                'Delivered': stats.completed_orders,
                'Cancelled': stats.cancelled_orders
            });

        } else {
            toast.error(data.message);
        }
        setIsLoader(false);
    } catch (error) {
        setIsLoader(false);
    }
   
};

  return (
    <div className="d-flex flex-column flex-column-fluid">
        <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
            <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                        Dashboard 
                    </h1>
                    <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <li className="breadcrumb-item text-muted">
                            <a href="/admin/" className="text-muted text-hover-primary"> Home </a>
                        </li>
                        <li className="breadcrumb-item">
                            <span className="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <li className="breadcrumb-item text-muted"> Dashboard </li>
                    </ul>
                </div>
                <div className="d-flex align-items-center gap-2 gap-lg-3">
                    {getHumanReadableDateRange(apiData.daterange)}
                    <RangePicker 
                        value={apiData.daterange }
                        ranges={ranges}
                        onChange={handleDateChange}
                        disabledDate={(current) => current && current > dayjs()}
                    />
                </div>
            </div>
        </div>

        <div id="kt_app_content" className="app-content flex-column-fluid">
            <div id="kt_app_content_container" className="app-container container-fluid">
                <div className="row g-5 g-xl-10 mb-5 mb-xl-10">

                    {!admin.branch_id &&
                        <div className="col-xl-3 col-md-6 mb-4">
                            <NavLink to="/branches" className="card border  shadow h-100 py-2">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2"> Total Branches </div>
                                            <div className="h1 mb-0 font-weight-bold text-gray-900">{stats?.total_branches}</div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="bi bi-building fs-3x text-gray-600"></i>
                                        </div>
                                    </div>
                                </div>
                            </NavLink>
                        </div>
                    }
                    {!admin.branch_id &&
                        <div className="col-xl-3 col-md-6 mb-4">
                            <NavLink to="/items" className="card border  shadow h-100 py-2">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2"> Total Items </div>
                                            <div className="h1 mb-0 font-weight-bold text-gray-900">{stats?.total_items}</div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="bi bi-cup-straw fs-3x text-gray-600"></i>
                                        </div>
                                    </div>
                                </div>
                            </NavLink>
                        </div>
                    }
                    {!admin.branch_id &&
                        <div className="col-xl-3 col-md-6 mb-4">
                            <NavLink to="/users" className="card border  shadow h-100 py-2">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2"> Total Customers </div>
                                            <div className="h1 mb-0 font-weight-bold text-gray-900">{stats?.total_users}</div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="bi bi-people-fill fs-3x text-gray-600"></i>
                                        </div>
                                    </div>
                                </div>
                            </NavLink>
                        </div>
                    }

                    

                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/orders" className="card border  shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2"> Total Orders </div>
                                        <div className="h1 mb-0 fw-bold text-gray-900">{stats?.total_orders}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-cart fs-3x text-gray-600"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>

                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/orders" className="card border  shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2"> Pickup Orders </div>
                                        <div className="h1 mb-0 fw-bold text-gray-900">{stats?.pickup_orders}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-bag-check-fill fs-3x text-gray-600"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>
                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/orders" className="card border  shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2"> Delivery Orders </div>
                                        <div className="h1 mb-0 fw-bold text-gray-900">{stats?.delivery_orders}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-truck fs-3x text-gray-600"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>

                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/orders" className="card border  shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2"> Active Orders  </div>
                                        <div className="h1 mb-0 fw-bold text-gray-900">{stats?.active_orders}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-cart-dash fs-3x text-gray-600"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>

            
                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/orders" className="card border  shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2"> Completed Orders </div>
                                        <div className="h1 mb-0 fw-bold text-gray-900">{stats?.completed_orders}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-cart-check fs-3x text-gray-600"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>

                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/orders" className="card border  shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2"> Cancelled Orders</div>
                                         <div className="h3 mb-0 fw-bold text-gray-900"> AED <br />
                                             {formatPrice(stats?.cancelled_amount   )}  ({stats?.cancelled_orders})</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-cart-x fs-3x text-gray-600"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>

                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/orders" className="card border  shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2"> Total Sales </div>
                                        <div className="h3 mb-0 fw-bold text-gray-900"> AED <br />
                                             {formatPrice(stats?.total_sales)}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-cash fs-3x text-gray-600"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>
                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/orders" className="card border  shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2"> Avg Order Amount </div>
                                        <div className="h3 mb-0 fw-bold text-gray-900"> AED <br />
                                             {formatPrice(stats?.avg_order)}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-cash fs-3x text-gray-600"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>

                </div>

                <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                    <div className="col-md-6">
                        <div className="card card-flush overflow-hidden">
                            <div className="card-header pt-5">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label fw-bold text-dark">  Orders Status </span>
                                    <span className="text-gray-400 mt-1 fw-semibold fs-6"> Current Orders Status</span>
                                </h3>
                                <div className="card-toolbar"></div>
                            </div>
                            <div className="card-body d-flex align-items-end">
                                <div className="p-chart h-300px w-100"  style={{ position: 'relative' }}>
                                    <PieChart statusData={pieData} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <ProgressBarStats 
                            title="Top Menu Items" 
                            data={stats?.top_items} 
                        />
                    </div>
                    <div className="col-md-6">
                        <ProgressBarStats 
                            title="Top Branches" 
                            data={stats?.top_branches} 
                        />
                    </div>
                    <div className="col-md-6">
                        <ProgressBarStats 
                            title="Top Customers" 
                            data={stats?.top_customers} 
                        />
                    </div>
                   
                    {!admin.branch_id &&
                    <div className="col-md-6">
                        <div className="card card-flush overflow-hidden">
                            <div className="card-header pt-5">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label fw-bold text-dark">Customers Stats</span>
                                    <span className="text-gray-400 mt-1 fw-semibold fs-6"> Customers registered per month</span>
                                </h3>
                                <div className="card-toolbar"></div>
                            </div>
                            <div className="card-body d-flex align-items-end">
                                <div className="p-chart h-300px w-100" style={{ position: 'relative' }}>
                                    <AreaChart labels={charts.months} label='Customers' dataset={charts.month_users} />
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    <div className="col-md-6">
                        <div className="card card-flush overflow-hidden">
                            <div className="card-header pt-5">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label fw-bold text-dark">  Monthly Orders </span>
                                    <span className="text-gray-400 mt-1 fw-semibold fs-6"> Orders per month</span>
                                </h3>
                                <div className="card-toolbar"></div>
                            </div>
                            <div className="card-body d-flex align-items-end">
                                <div className="p-chart h-300px w-100"  style={{ position: 'relative' }}>
                                <AreaChart labels={charts.months} label='Orders' dataset={charts.month_orders} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="card card-flush overflow-hidden">
                            <div className="card-header pt-5">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label fw-bold text-dark">  Monthly Revenue </span>
                                    <span className="text-gray-400 mt-1 fw-semibold fs-6">This Month Revenue</span>
                                </h3>
                                <div className="card-toolbar"></div>
                            </div>
                            <div className="card-body d-flex align-items-end">
                                <div className="p-chart h-300px w-100"  style={{ position: 'relative' }}>
                                <AreaChart labels={charts.months} label='Revenue' dataset={charts.month_revenue} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="card card-flush overflow-hidden">
                            <div className="card-header pt-5">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label fw-bold text-dark"> {current_month} Orders </span>
                                    <span className="text-gray-400 mt-1 fw-semibold fs-6">This Month Orders</span>
                                </h3>
                                <div className="card-toolbar"></div>
                            </div>
                            <div className="card-body d-flex align-items-end">
                                <div className="p-chart h-300px w-100"  style={{ position: 'relative' }}>
                                <AreaChart labels={charts.dates} label='Orders' dataset={charts.day_orders} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card card-flush overflow-hidden">
                            <div className="card-header pt-5">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label fw-bold text-dark"> {current_month} Revenue </span>
                                    <span className="text-gray-400 mt-1 fw-semibold fs-6">This Month Revenue</span>
                                </h3>
                                <div className="card-toolbar"></div>
                            </div>
                            <div className="card-body d-flex align-items-end">
                                <div className="p-chart h-300px w-100"  style={{ position: 'relative' }}>
                                <AreaChart labels={charts.dates} label='Revenue' dataset={charts.day_revenue} />
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
  );
};

export default Dashboard;
